var DefectsAndRecommendationsBoxModule = /** @class */ (function () {
    function DefectsAndRecommendationsBoxModule() {
    }
    return DefectsAndRecommendationsBoxModule;
}());
export { DefectsAndRecommendationsBoxModule };
